import { Reducer } from 'redux';
import { SpecialistActionTypes, SpecialistState } from './type';

const initialState: SpecialistState = {
  specialistConfig: {},
};

const reducer: Reducer<SpecialistState> = (state = initialState, action) => {
  switch (action.type) {
    case SpecialistActionTypes.SPECIALIST_BASE_CONFIG_REDUCER: {
      let { data = {} } = action;
      return {
        ...state,
        specialistConfig: {
          ...state.specialistConfig,
          ...data,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as SpecialistReducer };
